import {
  PaymentProfileFieldError,
  PaymentProfileFromType,
  PaymentProfileFields,
} from '../../machines';

type TokenizationError = {
  inner: { path: string; message: PaymentProfileFieldError }[];
};

/**
 * Serializes error recevied during payment method tokenization process.
 * @param {string} error - tokenization error
 * @returns {Record} payment profile fields errors
 */
export const serializeErrors = (error: TokenizationError) => {
  const errors: Record<
    PaymentProfileFromType,
    {
      [key: string]: PaymentProfileFieldError;
    }
  > = {
    paymentMethod: {},
    billingAddress: {},
  };

  error.inner.forEach(
    (fieldError: { path: string; message: PaymentProfileFieldError }) => {
      const [form, field] = fieldError.path.split('.') as [
        PaymentProfileFromType,
        PaymentProfileFields
      ];
      errors[form][field] = fieldError.message;
    }
  );

  return errors;
};
